import { Clock, Sparkles } from 'lucide-react';
import { useAIAllowance } from '../lib/aiAllowance';

interface Props {
  /** What still works while AI waits for the reset, added after the "none left" message. */
  fallback?: string;
  /** Lets the AI actions this note explains point at it (aria-describedby). */
  id?: string;
}

/**
 * The AI allowance, next to AI actions: "8 AI requests left today" once 10 or
 * fewer are left, or when AI comes back once none are (or the server-wide cap is
 * reached). Nothing otherwise, and nothing while AI is off (aiOff says why).
 *
 * It's a polite status that keeps its element from "low" to "out", so screen
 * readers hear the change. Its text only changes after an AI request or at the reset.
 */
export function AIRequestsLeft({ fallback, id }: Props) {
  const { message, exhausted } = useAIAllowance();
  if (!message) return null;
  return (
    <p id={id} role="status" className={exhausted ? 'ai-left ai-left--out' : 'ai-left'}>
      {exhausted ? <Clock size={16} aria-hidden="true" /> : <Sparkles size={14} aria-hidden="true" />}
      <span>{exhausted && fallback ? `${message} ${fallback}` : message}</span>
    </p>
  );
}
